import lightreachApi from "../api/lightreach-api";

export const getLightReachTpoPricing = async (payload) => {
  for (let i = 0; i < payload.offers.length; i++) {
    if (payload.offers[i].name === payload.name) {
      return payload.offers[i];
    }
  }
};

const processOffersTPO = (res) => {
  const offers = [];
  if (!res?.data) {
    return { success: false, message: res.message };
  }
  const response = res.data;
  for (let i = 0; i < response.length; i++) {
    const offer = {
      id: `${i}`,
      name: response[i].name,
      escalatorRate: response[i].escalationRate,
      projectTypeName: "PPA",
      pricing: response[i].pricing,
      productId: `${i}`,
      productCode: "LightReach PPA",
      term: response[i].term,
    };
    offers.push(offer);
  }
  return {
    offers: offers,
    success: true,
    message: res.message,
    lrId: res.lrId,
    status: res.status,
    identity: res.identity,
    title: res.title,
  };
};

export const getLightReachTpoOffers = async (payload) => {
  try {
    const response = await lightreachApi.getQuote(payload);
    if (!response.success && !response.data.length)
      throw new Error(response.message ? response.message: response.data.message);
    
    return processOffersTPO(response);
  } catch (error) {
    throw new Error(
      `Error: Could not get LightReach TPO Offers: ${
        error?.message ? error.message : ""
      } \n${error?.status ? error.status : ""} ${
        error?.statusText ? error.statusText : ""
      } ${error?.url ? error.url : ""}`
    );
  }
};

export const postLightReachShareLoanApplication = async ({
  sfProjectId,
  ...payload
}) => {
  return { data: payload };
};

export const sendLightReachContract = async (accountId, externalId) => {
  return lightreachApi.sendContract(accountId, externalId);
};

export const checkLightReachCustomerStatus = async (acctId) => {
  return lightreachApi.checkCustomerStatus(acctId);
};

export const emailLightReachCreditApplication = async ({
  firstName,
  acctId,
  email,
}) => {
  return lightreachApi.emailCreditApplication(firstName, acctId, email);
};

export const verifyLightReachUser = async (rep_email) => {
  return lightreachApi.verifyUser(rep_email);
};

export const uploadLightReachDocument = async (acctId, type, files) => {
  return lightreachApi.uploadDocument(acctId, type, files);
};
